import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "title"]

  connect() {
    // Listen for turbo:frame-load to know when content is loaded
    document.addEventListener("column-drawer:open", this.open.bind(this))
  }

  disconnect() {
    document.removeEventListener("column-drawer:open", this.open.bind(this))
  }

  open(event) {
    const { url, title } = event.detail || {}

    if (title && this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }

    if (url && this.hasContentTarget) {
      this.loadContent(url)
    }

    this.show()
  }

  async loadContent(url) {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      const html = await response.text()
      this.contentTarget.innerHTML = html
    } catch (error) {
      console.error("Failed to load drawer content:", error)
    }
  }

  show() {
    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.element.querySelector("[data-drawer-panel]")?.classList.remove("translate-x-full")
      this.element.querySelector("[data-drawer-overlay]")?.classList.remove("opacity-0")
    })
  }

  close(event) {
    if (event) event.preventDefault()
    const panel = this.element.querySelector("[data-drawer-panel]")
    const overlay = this.element.querySelector("[data-drawer-overlay]")

    panel?.classList.add("translate-x-full")
    overlay?.classList.add("opacity-0")

    setTimeout(() => {
      this.element.classList.add("hidden")
      if (this.hasContentTarget) {
        this.contentTarget.innerHTML = ""
      }
    }, 300)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }
}
